import { InfoOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';
import {
  DatePicker as MuiDatePicker,
  type DatePickerProps as MuiDatePickerProps,
  type PickerValidDate,
} from '@mui/x-date-pickers';

import { Tooltip } from '../Tooltip/Tooltip';

export type DatePickerProps<T extends PickerValidDate> = {
  infoTooltip?: string;
  fullWidth?: boolean;
} & MuiDatePickerProps<T>;

export const DatePicker = <T extends PickerValidDate>({
  infoTooltip,
  fullWidth = false,
  format = 'DD/MM/YYYY',
  ...rest
}: DatePickerProps<T>) => {
  return infoTooltip ? (
    <Box display="flex" gap={1}>
      <MuiDatePicker format={format} {...rest} sx={{ width: fullWidth ? '100%' : undefined }} />
      <Tooltip title={infoTooltip}>
        <InfoOutlined sx={{ marginTop: 1 }} />
      </Tooltip>
    </Box>
  ) : (
    <MuiDatePicker {...rest} />
  );
};
